module.exports = __webpack_public_path__ + "roundabout_left.svg?b6119797ffed248b70f1f69274c3fe5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_left.svg
// module id = 216
// module chunks = 0